import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DynamicDialogBaseComponent } from '@volt/shared/components/dialogs/dynamic-dialog/dynamic-dialog-base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'require-status-modal',
  templateUrl: './require-status-modal.component.html',
  styleUrls: [],
})
export class RequireStatusModalComponent extends DynamicDialogBaseComponent implements OnInit {
  message: string;

  constructor(
    public readonly _dialogReference: DynamicDialogRef,
    private readonly _dialogConfig: DynamicDialogConfig,
    private _router: Router,
  ) {
    super(_dialogReference, _dialogConfig);
  }

  ngOnInit() {
    this._router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this._dialogReference.close(false));

    this.message = this._dialogConfig.data.message;
  }

  public onClose() {
    this._dialogReference.close();
  }
}
